// extracted by css-extract-rspack-plugin
var _1 = "dEPcKA2zM7B5Bj7OT0Lq-A--";
var _2 = "_5ix3vH9OCEmeSrcfCPUuGQ--";
var _3 = "tjZDjMFC6OdUpwZImASCiw--";
export { _1 as "bankName", _2 as "container", _3 as "logoImg" }
